import { render, staticRenderFns } from "./EditTicket.vue?vue&type=template&id=6a47045c&scoped=true&"
import script from "./EditTicket.vue?vue&type=script&lang=js&"
export * from "./EditTicket.vue?vue&type=script&lang=js&"
import style0 from "./project-timeline.css?vue&type=style&index=0&id=6a47045c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47045c",
  null
  
)

export default component.exports